import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MessageCircle, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white pt-16 pb-8 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_program-curriculum/artifacts/5bzlurrn_new_logo.jpg"
              alt="CareerLift"
              className="h-16 mb-4 object-contain"
            />
            <p className="text-slate-300 text-sm leading-relaxed mb-4">
              Empowering careers through practical IT training and mentorship.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com/profile.php?id=61582878116205&mibextid=wwXIfr&mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-teal-500 backdrop-blur-sm rounded-full flex items-center justify-center transition-all hover:scale-110">
                <Facebook size={18} />
              </a>
              <a href="https://www.instagram.com/careerlift.au?igsh=MXFlNXo1MWRpZDFvMA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-teal-500 backdrop-blur-sm rounded-full flex items-center justify-center transition-all hover:scale-110">
                <Instagram size={18} />
              </a>
              <a href="https://youtube.com/@careerlift-it?si=TV3TlKCcH6JVv3TT" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-teal-500 backdrop-blur-sm rounded-full flex items-center justify-center transition-all hover:scale-110">
                <Youtube size={18} />
              </a>
            </div>
          </div>

          {/* Job Ready Programs */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-teal-400">Job Ready Programs</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/programs/system-network-engineer" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  System & Network Engineer
                </Link>
              </li>
              <li>
                <Link to="/programs/devops-engineer" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Cloud & DevOps Engineer
                </Link>
              </li>
              <li>
                <Link to="/ai-career-roadmap" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Free AI Career Assessment
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-teal-400">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & WhatsApp */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-teal-400">Get In Touch</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:info@careerlift.com.au" className="text-slate-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2">
                  <span>✉</span>
                  info@careerlift.com.au
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/61468607994" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold text-sm transition-all hover:scale-105"
                >
                  <MessageCircle size={18} />
                  Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} CareerLift. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/programs" className="text-slate-400 hover:text-teal-400 transition-colors text-sm">
              All Programs
            </Link>
            <Link to="/resources" className="text-slate-400 hover:text-teal-400 transition-colors text-sm">
              Resources
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
